export default {"src":"/_next/static/media/todo.879eddee.svg","height":38,"width":33};